let mab_bn; export default mab_bn = '240925366';
